export default "__VITE_ASSET__E1pix_4___"